import { ButtonBox } from '@doda/common/src/logics/seoNarrowDownButtonData/createSeoNarrowDownButton';
import { useAppDispatch } from '@doda/pc/src/redux/hooks';
import { FC, memo, MouseEventHandler } from 'react';
import { measureNarrowDownButtonClick } from '@doda/common/src/logics/seoNarrowDownButtonData/analytics/narrowDownButton';
import { SeoNarrowDownButtonItem } from './SeoNarrowDownButtonItem';

/**
 * SEO絞り込みボタン 大枠のProps
 * @param seoNarrowDownButtonData 絞り込みボタンデータ
 */
interface Props {
  seoNarrowDownButtonData: ButtonBox[] | undefined;
}
export const SeoNarrowDownButton: FC<Props> = memo(
  ({ seoNarrowDownButtonData }) => {
    // 絞り込みボタンクリック時計測用
    const dispatch = useAppDispatch();
    const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
      dispatch(measureNarrowDownButtonClick(event));
    };

    return (
      <>
        {seoNarrowDownButtonData?.map((narrowDownButtonBox, i) => (
          <SeoNarrowDownButtonItem
            narrowDownButton={narrowDownButtonBox}
            handleClick={handleClick}
            key={i}
          />
        ))}
      </>
    );
  }
);

SeoNarrowDownButton.displayName = 'SeoNarrowDownButton';
